(function () {
  var sizeConfirmed = false;
  var addToCartText = null;

  function findSizeFieldsets() {
    var fieldsets = document.querySelectorAll('fieldset.product-form__input--pill');
    var matches = [];
    fieldsets.forEach(function (fieldset) {
      var legend = fieldset.querySelector('legend');
      if (legend && /size/i.test(legend.textContent)) {
        matches.push(fieldset);
      }
    });
    return matches;
  }

  function setRequiredState(scope, satisfied) {
    var submitButton = scope.querySelector('.product-form__submit');
    if (submitButton) {
      var label = submitButton.querySelector('span');
      if (satisfied) {
        submitButton.removeAttribute('disabled');
        if (label && addToCartText !== null) {
          label.textContent = addToCartText;
        }
      } else {
        if (label && addToCartText === null) {
          addToCartText = label.textContent;
        }
        submitButton.setAttribute('disabled', 'disabled');
        if (label) {
          label.textContent = 'Select a size';
        }
      }
    }

    var dynamicCheckout = scope.querySelector('.shopify-payment-button');
    if (dynamicCheckout) {
      dynamicCheckout.classList.toggle('size-required-hidden', !satisfied);
    }
  }

  function initFieldset(fieldset) {
    if (sizeConfirmed) return;

    var scope = fieldset.closest('product-info') || document;

    if (!fieldset.dataset.sizeRequiredInit) {
      fieldset.dataset.sizeRequiredInit = 'true';
      fieldset.addEventListener('change', function (event) {
        if (event.target && event.target.matches('input[type="radio"]')) {
          sizeConfirmed = true;
          setRequiredState(scope, true);
        }
      });
    }

    fieldset.querySelectorAll('input[type="radio"]').forEach(function (radio) {
      radio.checked = false;
    });
    setRequiredState(scope, false);
  }

  function init() {
    findSizeFieldsets().forEach(initFieldset);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Dawn re-fetches and swaps in a fresh copy of the variant picker (and this fieldset
  // with it) on every option change, including a color-only change before any size has
  // been picked -- so without this, a size auto-selects again the moment someone touches
  // color first. Re-running init() here re-applies the "no default" state to the new
  // fieldset, but only until sizeConfirmed flips true; after a real size click, this is a
  // no-op forever and Dawn's own accurate re-render is left alone.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function () {
      try {
        init();
      } catch (error) {
        console.error('size-selection-required:', error);
      }
    });
  }
})();
